// extracted by mini-css-extract-plugin
export default {"bullpen-secondary-950":"#01080c","primary":"styles_primary__eZKbB","primaryDisabled":"styles_primaryDisabled__W6QES"};